import React, { Component } from "react"
import { Input, Button, Form } from "antd"
import moment from "moment/moment"

const FormItem = Form.Item

class EditEvidenceForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      evidence: props.data.ev || [],
      addingEvidence: false,
      title: props.data.ev.title,
      url: props.data.ev.url,
    }
  }

  onUpdateEvidence = (id) => {
    const { title, url, evidence } = this.state
    
    if(!navigator.onLine){
        const updatedEvidence = {
            ...evidence,
            isEditing: false,
          }
          this.setState({ evidence: updatedEvidence }, () => {
            this.props.onEvidenceChange(updatedEvidence)
          })
          message.error(this.props.intl.modalActionPlanCreate.createModal.evidence.ErrorEditEvidence)
          return;
    }
    const updatedEvidence = {
      ...evidence,
      title,
      url,
      isEditing: false,
      date: moment(),
      is_update: true,
    }

    
      this.setState({ evidence: updatedEvidence }, () => {
        this.props.onEvidenceChange(updatedEvidence)
      })
      message.success(this.props.intl.modalActionPlanCreate.createModal.evidence.editEvidenceSuccess)
   
  }

  onCancelUpdateEvidence = (id) => {
    const { evidence } = this.state
    const updatedEvidence = {
      ...evidence,
      isEditing: false,
    }

    this.setState({ evidence: updatedEvidence }, () => {
      this.props.onEvidenceChange(updatedEvidence)
    })
  }

  render() {
    const { evidence, addingEvidence, title, url } = this.state

    return (
      <div id={this.props.id}>
        <div key={evidence.id}>
          <div>
            {
              this.props.intl.modalActionPlanCreate.createModal.evidence
                .linkTitle
            }{" "}
            <span className="required">*</span>
          </div>
          <div>
            <FormItem>
              <Input
                key={`title-${evidence.id}`}
                maxLength={80}
                placeholder={
                  this.props.intl.modalActionPlanCreate.createModal.evidence
                    .linkTitlePlaceholder
                }
                value={title}
                onChange={(e) => this.setState({ title: e.target.value })}
              />
            </FormItem>
          </div>
          <div>
            {
              this.props.intl.modalActionPlanCreate.createModal.evidence
                .linkDescription
            }{" "}
            <span className="required">*</span>
          </div>
          <div>
            <FormItem>
              <Input
                key={`url-${evidence.id}`}
                maxLength={512}
                placeholder={
                  this.props.intl.modalActionPlanCreate.createModal.evidence
                    .linkDescriptionPlaceholder
                }
                value={url}
                onChange={(e) => this.setState({ url: e.target.value })}
              />
            </FormItem>
          </div>
          <Button
            type="primary"
            block
            disabled={!title?.trim() || !url?.trim()}
            loading={addingEvidence}
            onClick={(e) => {
              this.onUpdateEvidence(evidence.id)
            }}>
            {this.props.intl.modalActionPlanCreate.actions.save}
          </Button>
          <Button
            style={{ marginTop: 10, marginBottom: 20 }}
            type="default"
            block
            loading={addingEvidence}
            onClick={(e) => {
              this.onCancelUpdateEvidence(evidence.id)
            }}>
            {this.props.intl.modalActionPlanCreate.actions.cancel}
          </Button>
        </div>
      </div>
    )
  }
}

export default EditEvidenceForm
